/**
 * The order hospital and rehab stays read in, on the record's card and the
 * Client history (LP-19, Amanda: "should be reverse chronological"):
 * dated stays newest first by eventOn; a stay known only by its words
 * (dateText, no date) after them, in the order it was written. The server
 * read returns the same order (repos/clientRecord.ts); the sort is stable,
 * so it never re-orders what the server sent.
 */
import type { HospitalEventRow } from '@/lib/clientRecord';

export function byStayNewestFirst(a: Pick<HospitalEventRow, 'eventOn'>, b: Pick<HospitalEventRow, 'eventOn'>): number {
  if (a.eventOn !== undefined && b.eventOn !== undefined) return b.eventOn.localeCompare(a.eventOn);
  if (a.eventOn !== undefined) return -1;
  if (b.eventOn !== undefined) return 1;
  return 0;
}
